export default function ProfileTextBox({ text }) {
  return (
    <div className="bg-gray-50 border border-gray-100 rounded-lg p-4 mb-8 shadow-inner">
      <p className="text-gray-700 text-sm md:text-base leading-relaxed">
        {text || "من یک صاحب ایده هستم که تلاش می‌کنم خدمتی شایسته به خودم، خانواده‌ام و جامعه‌ام ارائه دهم."}
      </p>
    </div>
  );
}
